{
  "version": 1,
  "asset_id": "f11cfeae-8697-4533-8e83-0313ca7bffe0",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/f11cfeae-8697-4533-8e83-0313ca7bffe0/swatch-platinum.jpeg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/f11cfeae-8697-4533-8e83-0313ca7bffe0/swatch-platinum.jpeg",
  "original_filename": "swatch-platinum.jpeg",
  "size": 439076,
  "content_type": "image/jpeg",
  "created_at": "2026-08-02T15:18:16Z"
}
